import { render, staticRenderFns } from "./CustomerTransferList.vue?vue&type=template&id=bf6ff338&scoped=true"
import script from "./CustomerTransferList.vue?vue&type=script&lang=js"
export * from "./CustomerTransferList.vue?vue&type=script&lang=js"
import style0 from "./CustomerTransferList.vue?vue&type=style&index=0&id=bf6ff338&prod&lang=scss&scoped=true"
import style1 from "./CustomerTransferList.vue?vue&type=style&index=1&id=bf6ff338&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf6ff338",
  null
  
)

export default component.exports